import { createAsyncThunk } from "@reduxjs/toolkit";
import { modalActions } from "../ModalSlice";
import { JEDI_HR_URL } from "../../constants";
import axiosClient from "../../utils/axiosClient";
import { loadingActions } from "../LoaderSlice";
import axios from "axios";

// GET AREA LIST
export const getPeopleDetails = createAsyncThunk(
  "people/get_people_details",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getPeopleDetails : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = payload?.draft
      ? "/get_people_draft_details"
      : "/get_people_details";
    const url = baseURL + path;
    try {
      const { draft, ...filteredPayload } = payload;
      // Send pagination parameters in the payload
      const response = await axiosClient.post(url, {
        ...filteredPayload,
        offset: payload.offset || 0,
        limit: payload.limit || 20,
      });

      dispatch(loadingActions.setLoading(false));
      console.log("getPeopleDetails response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error :  ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const getuserDetails = createAsyncThunk(
  "people/get_user_details",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getuserDetails : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = payload?.draft
      ? "/get_draft_user_details"
      : "/get_user_details";

    // const path = "/get_user_details";
    const url = baseURL + path;
    try {
      const { draft, ...filteredPayload } = payload;
      const response = await axiosClient.post(url, filteredPayload);

      dispatch(loadingActions.setLoading(false));
      console.log("getuserDetails response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error :  ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const searchUserDetails = createAsyncThunk(
  "people/search_user",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    // dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside searchUserDetails : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = payload?.draft ? "/search_draft_user" : "/search_user";

    const url = baseURL + path;
    try {
      const { draft, ...filteredPayload } = payload;
      const response = await axiosClient.post(url, filteredPayload);

      dispatch(loadingActions.setLoading(false));
      console.log("searchUserDetails response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error :  ", error);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const createUserDetails = createAsyncThunk(
  "people/create_user",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside createUserDetails : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/create_user";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("createUserDetails response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error :  ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const createEmployeeId = createAsyncThunk(
  "people/create_emp_id",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside createEmployeeId : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/create_emp_id";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("createEmployeeId response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error :  ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const saveUserAsDraft = createAsyncThunk(
  "people/create_user_draft",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside saveUserAsDraft : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/create_user_draft";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("saveUserAsDraft response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error :  ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
export const updateUserDetails = createAsyncThunk(
  "people/update_user_details",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside updateUserDetails : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/update_user_details";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("updateUserDetails response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error :  ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
export const updateBankDetails = createAsyncThunk(
  "people/update_bank_details",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside updateBankDetails : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/update_bank_details";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("updateBankDetails response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error :  ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const uploadFileWithPresignedUrl = createAsyncThunk(
  "people/generate_presigned_url",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside uploadFileWithPresignedUrl : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/generate_presigned_url";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, {
        employee_id: payload.employee_id,
        file_name: payload.file.name,
        key: payload.key,
      });

      dispatch(loadingActions.setLoading(false));
      console.log("uploadFileWithPresignedUrl response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      const fileUploadData = new FormData();
      Object.keys(response?.data?.presigned_url?.fields).forEach((key) => {
        fileUploadData.append(key, response?.data?.presigned_url.fields[key]);
      });
      fileUploadData.append("file", payload.file);
      const fileUploadResponse = await axios.post(
        response?.data?.presigned_url.url,
        fileUploadData,
      );

      if (fileUploadResponse.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message: "Error : " + fileUploadResponse?.data?.error_message,
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          fileUploadResponse?.data?.error_message ||
            fileUploadResponse?.data?.message,
        );
      }

      return {
        key: payload.key,
        presignedUrlResponse: response?.data?.presigned_url,
        response: fileUploadResponse.data,
      };
    } catch (error) {
      console.log("Error :  ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const bulkUpdateWithPresignedUrl = createAsyncThunk(
  "people/update_with_presigned_url",
  async (data, { dispatch, getState, rejectWithValue }) => {
    let payload = data.payload;
    let file = data.file;

    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getPresignedURL : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/generate_presigned_url";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      // dispatch(loadingActions.setLoading(false));
      console.log("getPresignedURL response : ", response.data);

      if (response.data.status === "error") {
        dispatch(loadingActions.setLoading(false));
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      } else if (response.data?.status === "success") {
        const presigned_url = response.data?.presigned_url?.url;

        const formData = new FormData();

        Object.entries(response.data?.presigned_url?.fields).forEach(
          ([key, value]) => {
            formData.append(key, value);
          },
        );

        formData.append("file", file);

        console.log("\n\n\n\nFormdata : ", formData);

        try {
          const uploadResponse = await axios.post(
            presigned_url,
            formData,
            // {
            //     headers: { "Content-Type": "multipart/form-data" },
            // }
          );

          console.log("upload ", uploadResponse);

          dispatch(loadingActions.setLoading(false));

          if (uploadResponse.status === 204) {
            console.log("File uploaded successfully!");
            // this is just for the bulk upload
            if (payload.key === "bulk_update_user_details") {
              const newPayload = {
                key: response.data?.presigned_url?.fields?.key,
              };
              console.log("\n\nInside bulk_upload : ", newPayload);
              const baseURL = "https://" + JEDI_HR_URL;

              const path = "/bulk_update_user_details";
              const url = baseURL + path;
              dispatch(loadingActions.setLoading(true));

              try {
                const response = await axiosClient.post(url, newPayload);
                console.log("bulk_upload response", response);
                dispatch(loadingActions.setLoading(false));
                if (response.data.status === "error") {
                  dispatch(
                    modalActions.setErrorModal({
                      message:
                        "Error : " +
                        (response?.data?.message ||
                          response?.data?.error_message),
                      status: "error",
                      state: true,
                      details: response?.data?.details || [],
                      url: response?.data?.url,
                    }),
                  );
                  return rejectWithValue(
                    response?.data?.error_message || response?.data?.message,
                  );
                }
                return response.data;
              } catch (error) {
                console.log("Error getAllReportees : ", error.message);

                dispatch(loadingActions.setLoading(false));
                dispatch(
                  modalActions.setErrorModal({
                    message: error?.message,
                    status: error.status,
                    state: true,
                  }),
                );
                return rejectWithValue(error);
              }
            }
          } else {
            console.error("Upload failed:", uploadResponse);
            return rejectWithValue(
              uploadResponse?.data?.error_message ||
                uploadResponse?.data?.message,
            );
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          dispatch(loadingActions.setLoading(false));
          dispatch(
            modalActions.setErrorModal({
              message: error?.message,
              status: error.status,
              state: true,
            }),
          );
        }
        return response.data;
      }
    } catch (error) {
      console.log("Error get_presigned_url : ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const getDropDownList = createAsyncThunk(
  "people/get_dropdown",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log("\n\nInside getDropDownList : ", payload);

    const baseURL = "https://" + JEDI_HR_URL;

    const path = "/get_dropdown";
    const url = baseURL + path;
    try {
      const response = await axiosClient.post(url, payload);

      dispatch(loadingActions.setLoading(false));
      console.log("getDropDownList response : ", response.data);

      if (response.data.status === "error") {
        dispatch(
          modalActions.setErrorModal({
            message:
              "Error : " +
              (response?.data?.message || response?.data?.error_message),
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message || response?.data?.message,
        );
      }

      return response.data;
    } catch (error) {
      console.log("Error :  ", error.message);

      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: error?.message,
          status: error.status,
          state: true,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const downloadBulkTemplate = createAsyncThunk(
  "people/download_bulkTemplate",
  async (payload, { dispatch, getState, rejectWithValue }) => {
    dispatch(loadingActions.setLoading(true));

    console.log(
      "\n\nRequesting bulk_user_creation_template with payload: ",
      payload,
    );

    const baseURL = "https://" + JEDI_HR_URL;
    const path = "/bulk_user_creation_template";
    const url = baseURL + path;

    try {
      const response = await axiosClient.post(url, payload);

      console.log("bulk_user_creation_template response : ", response.data);

      if (
        response.data.status === "success" &&
        response.data.isBase64Encoded &&
        response.data.body
      ) {
        // --- Define file details based on known information ---
        const fileMimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const fileName = "bulk_template.xlsx";
        // -----------------------------------------------------

        try {
          // Trigger the download directly from the thunk
          handleBase64Download(response.data.body, fileMimeType, fileName);
          // Still return the original success response data
          dispatch(loadingActions.setLoading(false));
          return response.data;
        } catch (downloadError) {
          console.error("Error during download handling:", downloadError);
          dispatch(loadingActions.setLoading(false));
          dispatch(
            modalActions.setErrorModal({
              message: `Download failed: ${downloadError.message}`,
              status: "error",
              state: true,
            }),
          );

          return rejectWithValue({
            message: downloadError.message,
            status: "error",
          });
        }
      } else if (response.data.status === "error") {
        dispatch(loadingActions.setLoading(false));
        dispatch(
          modalActions.setErrorModal({
            message:
              response?.data?.message ||
              response?.data?.error_message ||
              "Unknown API error",
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          response?.data?.error_message ||
            response?.data?.message ||
            "Unknown API error",
        );
      } else {
        dispatch(loadingActions.setLoading(false));
        console.error(
          "Received unexpected status from API:",
          response.data.status,
        );
        dispatch(
          modalActions.setErrorModal({
            message: `Received unexpected status: ${response.data.status}`,
            status: "error",
            state: true,
          }),
        );
        return rejectWithValue(
          `Unexpected API status: ${response.data.status}`,
        );
      }
    } catch (error) {
      // Handle network errors or errors during the axios request itself
      console.error("Error during API call: ", error);
      dispatch(loadingActions.setLoading(false));
      dispatch(
        modalActions.setErrorModal({
          message: `Network or Request Error: ${error?.message || "Unknown error"}`,
          // Attempt to get status from error response if available
          status: error?.response?.status || "error",
          state: true,
        }),
      );
      // Reject with the error object or a simplified message
      return rejectWithValue(error.message || error);
    }
  },
);

const handleBase64Download = (base64Data, mimeType, fileName) => {
  try {
    // 1. Decode Base64
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // 2. Create a Blob
    const blob = new Blob([byteArray], { type: mimeType });

    // 3. Create an Object URL
    const url = URL.createObjectURL(blob);

    // 4. Trigger Download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName); // Set the desired filename
    document.body.appendChild(link); // Required for Firefox
    link.click();
    document.body.removeChild(link); // Clean up link element

    // 5. Clean Up Object URL
    setTimeout(() => URL.revokeObjectURL(url), 100);

    console.log(`File download triggered: ${fileName}`);
  } catch (error) {
    console.error(`Error processing base64 file "${fileName}":`, error);
    // Optionally dispatch an error modal action here if needed
    // dispatch(modalActions.setErrorModal({ message: `Error processing download: ${error.message}`, status: 'error', state: true }));
    // Rethrow or handle as appropriate for the thunk flow
    throw new Error(`Failed to process and download file: ${error.message}`);
  }
};
